import { Team__Adrianes } from "./teams/Adrianes";
import { Team__Cerveceros_2 } from "./teams/Cerveceros_2";
import { Team__Joeles } from "./teams/Joeles";
import { Team__Llamas } from "./teams/Llamas";
import { Team__Lorenas } from "./teams/Lorenas";
import { Team__LosQuintanas } from "./teams/LosQuintanas";
import { Team__Natalias } from "./teams/Natalias";
import { Team__PecanBros } from "./teams/PecanBros";
import { Team__Potros } from "./teams/Potros";
import { Team__Pythons } from "./teams/Pythons";
import { Team__RoadRunner } from "./teams/RoadRunner";
import { Team__RWE } from "./teams/RWE";
import { Team__Wolfpack } from "./teams/Wolfpack";

export const teamList_2025_mensB = [
  Team__Adrianes,
  Team__Cerveceros_2,
  Team__Natalias,
  Team__Joeles,
  Team__Llamas,
  Team__LosQuintanas,
  Team__PecanBros,
  Team__Potros,
  Team__Pythons,
  Team__RoadRunner,
  Team__RWE,
  Team__Wolfpack,
];
